module.exports = __webpack_public_path__ + "media/metronic/_theme/media/products/product8-e6bd25d8bb38db57ddabf6c10b0246ce.jpg";